export class RelFinanceiroFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getRelMensal(data, filter) {
    const filtredParams = filter ? { ...filter } : {};

    delete filtredParams.intervalo;
    return this.instance.post('/v1/financeiro/relatorios/', data, {
      params: filtredParams,
    });
  }
}

export default RelFinanceiroFactory;
